import { useTranslation } from 'react-i18next'

import { Alert, Divider, Text, UploadImage } from '@reveni-io/reveni-ui'

import { acceptedImageTypes } from '@/configuration/pages/ConfigurationPage/ReturnProtectionConfiguration/ReturnProtectionAppearanceConfiguration/constants'
import ResetToDefaultButton from '@/configuration/pages/ConfigurationPage/ReturnProtectionConfiguration/ReturnProtectionAppearanceConfiguration/ResetToDefaultButton/ResetToDefaultButton'

import AppearanceColorField from '../AppearanceColorField/AppearanceColorField'
import { popupBackgroundColor, widgetPreviewViews } from '../constants'
import { getFieldError } from '../helpers'
import SectionIntro from '../SectionIntro/SectionIntro'
import WidgetPreview from '../WidgetPreview/WidgetPreview'
import * as Styles from './styles'

const PopupBlock = ({
  appearance,
  fieldErrors,
  uploaderKey,
  hasNewHeaderImage,
  onChangeColor,
  onChangeHeaderImage,
  onDiscardHeaderImage,
  onReset,
  resetting,
  disabled,
  resetDisabled,
}) => {
  const { t } = useTranslation()

  return (
    <Styles.Block>
      <SectionIntro
        title={t('Popup')}
        description={t(
          'Personaliza cómo se ve el popup de Return Protection para que encaje con el branding de tu tienda.'
        )}
      >
        <Alert type="info">{t('Los textos no se pueden personalizar en esta versión.')}</Alert>
      </SectionIntro>
      <Styles.Content>
        <Styles.Fields>
          <Text type="titleS">{t('Cabecera')}</Text>
          <UploadImage
            key={uploaderKey}
            label={t('Imagen de cabecera')}
            buttonText={t('Subir archivo')}
            recommendation={t('JPG, PNG - se recomienda 16:9, mín. 800x450px')}
            defaultImage={appearance.popup_header_image_url}
            onChange={onChangeHeaderImage}
            onDelete={hasNewHeaderImage ? onDiscardHeaderImage : undefined}
            accept={acceptedImageTypes}
            errorMessage={getFieldError(fieldErrors, 'popup_header_image')}
            disabled={disabled}
          />
          <AppearanceColorField
            field="popup_overlay_color"
            label={t('Color de superposición')}
            recommendation={t('Capa semitransparente sobre la imagen de cabecera.')}
            color={appearance.popup_overlay_color}
            error={getFieldError(fieldErrors, 'popup_overlay_color')}
            onChange={onChangeColor}
            disabled={disabled}
          />
          <AppearanceColorField
            field="popup_header_text_color"
            label={t('Color del texto de cabecera')}
            recommendation={t('Se aplica a opacidad completa en el texto de cabecera.')}
            color={appearance.popup_header_text_color}
            contrastColor={appearance.popup_overlay_color}
            error={getFieldError(fieldErrors, 'popup_header_text_color')}
            onChange={onChangeColor}
            disabled={disabled}
          />
          <Divider />
          <Text type="titleS">{t('Cuerpo')}</Text>
          <AppearanceColorField
            field="popup_body_text_color"
            label={t('Color del texto del cuerpo')}
            recommendation={t(
              'Se aplica a opacidad completa en títulos y texto en negrita. El texto secundario usa el mismo color al 60% de opacidad.'
            )}
            color={appearance.popup_body_text_color}
            contrastColor={popupBackgroundColor}
            error={getFieldError(fieldErrors, 'popup_body_text_color')}
            onChange={onChangeColor}
            disabled={disabled}
          />
          <ResetToDefaultButton onClick={onReset} loading={resetting} disabled={resetDisabled} />
        </Styles.Fields>
        <WidgetPreview view={widgetPreviewViews.popup} appearance={appearance} />
      </Styles.Content>
    </Styles.Block>
  )
}

export default PopupBlock
